import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxDescriptionFn = /* @__PURE__ */ createRecipe('checkbox-description', {}, [])

const checkboxDescriptionVariantMap = {}

const checkboxDescriptionVariantKeys = Object.keys(checkboxDescriptionVariantMap)

export const checkboxDescription = /* @__PURE__ */ Object.assign(memo(checkboxDescriptionFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxDescription',
  __getCompoundVariantCss__: checkboxDescriptionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxDescriptionVariantKeys,
  variantMap: checkboxDescriptionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxDescriptionVariantKeys)
  },
  getVariantProps: checkboxDescriptionFn.getVariantProps,
})